import { emailRegExpServer } from './auth'

export const isEmail = (email: string) => {
  return emailRegExpServer.test(email)
}

const phoneReg = /^01(0|1[6-9])(\d{4})(\d{4})$/
const phoneReg2 = /^10(\d{4})(\d{4})$/

export const isKrPhone = (phone: string) => {
  return phone === '99999999999' || phoneReg.test(phone) || phoneReg2.test(phone)
}
